<template>
	<div class="addClinic">
		<div class="fl">
			<div>
				<div>
					<p>诊所</p>
					<p>信息</p>
				</div>
				<div>
					<p>管理者</p>
					<p>信息</p>
				</div>
			</div>
		</div>
		<div class="">
			<div class="zsxxFrom">
				<div v-show="false">
					<span>诊所信息</span>
					<div>
						<button @click="xxgsVal=false">
							返回
						</button>
					</div>
					<div>
						<button @click="xgxxFn">
							修改确认
						</button>
					</div>
				</div>
				<div>
					<div class="fromIpt">
						<div>
							<div class="comClass">
								<p>
									<i></i> 诊所名称 (必填)
								</p>
								<div>
									<el-input v-model="nameVal" placeholder="请输入内容"></el-input>
								</div>
							</div>
							<div class="comClass">
								<p>
									<i></i> 诊所简称  (最多可输入4个字) (必填)
								</p>
								<div>
									<el-input v-model="minname" maxlength="4" placeholder="请输入内容"></el-input>
								</div>
							</div>
							<div class="comClass" v-show="false">
								<p>
									<i></i> 设置诊所登录密码
								</p>
								<div>
									<el-input v-model="zspwdVal" placeholder="请输入内容" disabled></el-input>
								</div>
							</div>
							<div class="comClass1">
								<p>
									<i></i> 地区 (必填)
								</p>
								<div style="overflow: hidden;">
									<div class="selectDiv fl">
										<div class="fl">
											<el-select v-model="sheng" placeholder="" @change="shiFn">
												<el-option v-for="(item,index) in sList" :key="index" :label="item.cName" :value="item.id">
												</el-option>
											</el-select>
										</div>
										<span class="fl">
											<p>省/</p>
											<p>直辖市</p>
										</span>
									</div>
									<div class="selectDiv1 fl">
										<div class="fl">
											<el-select v-model="shi" placeholder="" @change="xianFn">
												<el-option v-for="(item,index) in shiList" :key="index" :label="item.cName" :value="item.id">
												</el-option>
											</el-select>
										</div>
										<span class="fl">
											<p>市</p>
										</span>
									</div>
									<!--<div class="selectDiv fl">
										<div class="fl">
											<el-select v-model="xian" placeholder="">
												<el-option v-for="(item,index) in xianList" :key="index" :label="item.cName" :value="item.id">
												</el-option>
											</el-select>
										</div>
										<span class="fl">
											<p>区/县</p>
										</span>
									</div>-->
								</div>
							</div>
							<div class="comClass">
								<p>
									<i></i> 详细地址 (必填)
								</p>
								<div>
									<el-input v-model="addressVal" placeholder="请输入内容"></el-input>
								</div>
							</div>
							
						</div>
					</div>
					<div class="fromIpt1">
						<div>
							<div class="comClass">
								<p>
									<i></i> 联系电话 (必填)
								</p>
								<div>
									<el-input v-model="lxtel" placeholder="请输入内容"></el-input>
								</div>
							</div>
							<div class="comClass">
								<p>
									<i></i> 官方网站 (选填)
								</p>
								<div>
									<el-input v-model="gfwzVal" placeholder="请输入内容"></el-input>
								</div>
							</div>
							<div class="comClass">
								<p>
									<i></i> 公众号 (选填)
								</p>
								<div>
									<el-input v-model="vxVal" placeholder="请输入内容"></el-input>
								</div>
							</div>
							<div class="comClass2">
								<p>
									<i></i> 认证材料 (必填)
								</p>
								<div>
									<div class="fl">
										<el-upload class="avatar-uploader" action="https://api.bats-bio.com/ajax/" accept=".png,.jpg" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
											<img v-if="ylImg" :src="ylImg" class="avatar">
											<i v-else class="el-icon-picture"></i>
										</el-upload>
										<span>医疗诊所执业许可</span>
									</div>
									<div class="fr">
										<el-upload class="avatar-uploader" action="https://api.bats-bio.com/ajax/" accept=".png,.jpg" :show-file-list="false" :on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload">
											<img v-if="yyImg" :src="yyImg" class="avatar">
											<i v-else class="el-icon-picture"></i>
										</el-upload>
										<span>营业执照</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="glzxx">
				<div>
					<div class="">
						<p>
							<i></i> 姓名
						</p>
						<div>
							<!--<el-form-item prop="mobile">-->
								<el-input  v-model="glzName" placeholder="请输入内容"></el-input>
							<!--</el-form-item>-->
						</div>
					</div>
					<div class="">
						<p>
							<i></i> 联系电话
						</p>
						<div>
							<el-input v-model="glzTel" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div>
						<div>
							<button @click="xgxxFn" :disabled="shengqing"> 提交申请</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { company_row, city_ztree, users_list, get_company, company_save, imgbase64upload, users_delete_from_company ,company_list} from '../../http/api.js'
	export default {
		data() {
			return {
				companysrow: {},
				csVal: '',
				glList: [],
				drList: [],
				atList: [],
				addCyBool: false,
				tdlist: [],
				tel: '',
				xxgsVal: false,
				nameVal: '',
				zspwdVal: '1234abcd',
				addressVal: '',
				lxtel: '',
				gfwzVal: '',
				vxVal: '',
				ylImg: '',
				yyImg: '',
				sList: [],
				sheng: '',
				shiList: [],
				shi: '',
				xianList: [],
				xian: '',
				glzName:'',
				glzTel:'',
				addClinic:true,
				minname:'',
				shengqing:false
			}
		},
		beforeMount(){
			this.chengshiFn()
		},
		created() {
			this.chengshiFn()
		},
		mounted() {
			this.chengshiFn()
		},
		methods: {
			yyxkImgFn() {
				this.yyxkImg = true;
				this.yyzzImg = false;
			},
			yyzzImgFn() {
				this.yyzzImg = true;
				this.yyxkImg = false;
			},
			imgCloseFn() {
				this.yyzzImg = false;
				this.yyxkImg = false;
			},
			up(a, b) {
				return a.uTypeID - b.uTypeID
			},
			city_ztreeFn(val, val1) {
				city_ztree().then(res => {
					var data = res.data;
					for(var i = 0; i < data.length; i++) {
						if(data[i].id == val) {
							var a = data[i].name
						}
					}
					for(var j = 0; j < data.length; j++) {
						if(data[j].id == val1) {
							var b = data[j].name
						}
					}
					this.csVal = a + '/' + b
				})
			},
			chengshiFn() {
				var data = {
					pid: 100000
				}
				city_ztree(data).then(res => {
					var data = res.data;
					for(var i = 0; i < data.length; i++) {
						this.sList.push(data[i]);
					}
				})
			},
			shiFn() {
				this.shiList = [];
				this.shi = '';
				var data = {
					pid: this.sheng
				}
				city_ztree(data).then(res => {
					var data = res.data;
					for(var i = 0; i < data.length; i++) {
						this.shiList.push(data[i]);
					}
				})
			},
			xianFn() {
				this.xianList = [];
				this.xian = '';
				var data = {
					pid: this.shi
				}
				city_ztree(data).then(res => {
					var data = res.data;
					for(var i = 0; i < data.length; i++) {
						this.xianList.push(data[i]);
					}
				})
			},
			xgxxFn() {
				if(this.glzName==""){
					this.$message({
						message: '请输入管理员姓名',
						type: 'error',
						duration: 1000,
						onClose: () => {}
					})
				}else if(this.cTel==""){
					this.$message({
						message: '请输入管理员电话',
						type: 'error',
						duration: 1000,
						onClose: () => {}
					})
				}else if(this.minname==""){
					this.$message({
						message: '请输入诊所简称',
						type: 'error',
						duration: 1000,
						onClose: () => {}
					})
				}else{
					this.arrsomeFn();
				}
			},
			arrsomeFn(){
				company_list().then(res=>{
					var arr = [];
					 arr = res.data;
					 console.log(arr)
					console.log(this.arrfindFn(arr,this.nameVal))
					if(this.arrfindFn(arr,this.nameVal)){
						this.$message({
								message: "已存在诊所名称，请联系管理员确认或认领诊所",
								type: 'info',
								duration: 1000,
								onClose: () => {
								}
							})
					}else{
						this.company_saveFn()
					}
				}) 
			},
			company_saveFn(){
				this.shengqing=true;
				var data = {
					cTypeID: '1',
					cName: this.nameVal,
					cCpyTel: this.lxtel,
					cPerson:this.glzName,
					cTel:this.glzTel,
					cAddr: this.addressVal,
					cProvinceID: this.sheng,
					cCityID: this.shi,
					cLatLng:'',
					cIsShowSlideSelf: '1',
					cUrl: this.gfwzVal,
					cWxImg: this.vxVal,
					cImgA: this.ylImg,
					cImgB: this.yyImg,
					cRoute:this.addressVal,
					cNickName:this.minname
				}
				company_save(data).then(res => {
					var that = this;
					if(res.result == 1) {
						that.$message({
							message: res.msg,
							type: 'success',
							duration: 1000,
							onClose: () => {
								this.creaddataFn();									
							}
						})
					} else {
						that.$message({
							message: res.msg,
							type: 'error',
							duration: 1000,
							onClose: () => {
								this.shengqing=false;
							}
						})
					}
				})
			},
			arrfindFn(arr,target){
				 for (var i = 0; i < arr.length; i++) {
				    if (arr[i].cName === target) {
				      return true;
				    }
				  }
				  return false;
			},
			deleteFn(id) {
				var data = {
					uid: id
				}
				users_delete_from_company(data).then(res => {
					if(res.result == 1) {
						this.$message({
							message: res.msg,
							type: 'success',
							duration: 1000,
							onClose: () => {
								this.glListFn();
								this.drListFn();
								this.atListFn();
							}
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
							duration: 1000,
							onClose: () => {}
						})
					}
				})
			},
			creaddataFn(){
				this.nameVal = '';
				this.minname = '';
				this.lxtel ='';
				this.ylImg = '';
				this.yyImg = '';
				this.vxVal = '';
				this.gfwzVal = '';
				this.addressVal = '';
				this.zspwdVal = '';
				this.shi = '';
				this.sheng = '';
				this.glzName='';
				this.glzTel='';
				this.shengqing=false;
			},
			checkActiveFn(event) {
				var el = event.target;
				if($(el).is('.active')) {
					$(el).removeClass('active');
				} else {
					$(el).addClass('active');
				}
			},
			companys_rowFn() {
				companys_row().then(res => {
					if(res.result == 1) {
						this.companysrow = res.row;
						this.city_ztreeFn(this.companysrow.cProvinceID, this.companysrow.cCityID);
						this.datayzFn(this.companysrow)
						this.glListFn();
						this.drListFn();
						this.atListFn();
					} else {

					}
				})
			},
			datayzFn(data) {
				this.nameVal = data.cName;
				 this.lxtel=data.cCpyTel;
				this.glzTel = data.cTel;
				this.ylImg = data.cImgA;
				this.yyImg = data.cImgB;
				this.vxVal = data.cWxImg;
				this.gfwzVal = data.cUrl;
				this.addressVal = data.cAddr;
				this.zspwdVal = data.userpwd;
				this.shengId = data.cProvinceID;
				this.shiId = data.cCityID;
				this.sheng = data.cProvinceID;
				city_ztree().then(res => {
					var data = res.data;
					for(var i = 0; i < data.length; i++) {
						if(data[i].pId == this.sheng) {
							this.shiList.push(data[i]);
						}
					}
				})
				if(this.shiList != []) {
					this.shi = data.cCityID;
				}
				city_ztree().then(res => {
					var data = res.data;
					for(var i = 0; i < data.length; i++) {
						if(data[i].pId == this.shi) {
							this.xianList.push(data[i]);
						}
					}
				})
			},
			yqgrFn() {
				var data = {
					tel: this.tel
				}
				get_company(data).then(res => {
					if(res.result == 1) {
						this.$message({
							message: res.msg,
							type: 'success',
							duration: 1000,
							onClose: () => {}
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'info',
							duration: 1000,
							onClose: () => {}
						})
					}
				})
			},
			city_ztreeFn(val, val1) {
				city_ztree().then(res => {
					var data = res.data;
					for(var i = 0; i < data.length; i++) {
						if(data[i].id == val) {
							var a = data[i].name
						}
					}
					for(var j = 0; j < data.length; j++) {
						if(data[j].id == val1) {
							var b = data[j].name
						}
					}
					this.csVal = a + '/' + b
				})
			},
			handleAvatarSuccess(res, file) {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.2)'
				});
				let that = this;
				var reader = new FileReader();
				reader.readAsDataURL(file.raw);
				var img = new Image;
				var a = 0;
				var name = file.name;
				reader.onload = function() {
					let base64Str = reader.result.split(',')[1];
	                img.src = this.result;
					this.dataobj = {
						img_str: img.src,
						dir:'upload/file',
						file_name:name
						
					}
					imgbase64upload(this.dataobj).then(res => {
						if(res.result == 1) {
							var image1 =res.img;
							that.$message({
								message: '上传成功',
								type: 'success',
								duration: 1000,
								onClose: () => {
									loading.close();
									that.ylImg = image1;
								}
							})
						} else {
							that.$message({
								message: '图片加载失败',
								type: 'error',
								duration: 1000,
								onClose: () => {
									loading.close();
									that.BATSimageBannercenter = '';
								}
							})
						}
					})
				};
				reader.onerror = function(error) {
					console.log('Error: ', error);
				};
			},
			 beforeAvatarUpload(file){

	    	 	if (!/^image\/(jpeg|png)$/.test(file.type)) {
			          this.$confirm('上传图片暂时只支持PNG/JPG格式', '提示', {
			            confirmButtonText: '确定',
			            type: 'error' ,
			            callback: action => {
			
			            }
			          })
			    }
//			      return isJPG;
			},
			tabClick(str, el) {
				var el = event.currentTarget;
				$(el).addClass('active').siblings().removeClass('active')
				if(str == '1') {
					this.mzglBool = true;
					this.cyglBool = false;
				} else if(str == '2') {
					this.cyglBool = true;
					this.mzglBool = false;
					this.xxgsVal = false;
				}
			},
			handleAvatarSuccess1(res, file) {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.2)'
				});
				let that = this;
				var reader = new FileReader();
				reader.readAsDataURL(file.raw);
				var img = new Image;
				var a = 0;
				var name = file.name
				reader.onload = function() {
					let base64Str = reader.result.split(',')[1];
	                img.src = this.result;
					this.dataobj = {
						img_str: img.src,
						dir:'upload/file',
						file_name:name
					}
					imgbase64upload(this.dataobj).then(res => {
						if(res.result == 1) {
							var image1 =res.img;
							that.$message({
								message: '上传成功',
								type: 'success',
								duration: 1000,
								onClose: () => {
									loading.close();
									that.yyImg = image1;
								}
							})
						} else {
							that.$message({
								message: '图片加载失败',
								type: 'error',
								duration: 1000,
								onClose: () => {
									loading.close();
									that.BATSimageBannercenter = '';
								}
							})
						}
					})
				};
				reader.onerror = function(error) {
					console.log('Error: ', error);
				};
			},
			beforeAvatarUpload() {
			
			},
		}
	}
</script>

<style scoped>
	.addClinic {
		width: 100%;
		height: 100%;
		background: RGBA(245, 245, 245, 1);
	}
	
	.addClinic>.fl:nth-child(1) {
		height: 100%;
	}
	
	.addClinic>.fl:nth-child(1)>div {
		width: 76px;
		height: 100%;
		border-right: 3px solid #FFFFFF;
	}
	
	.addClinic>.fl:nth-child(1)>div>div {
		text-align: center;
		overflow: hidden;
	}
	
	.addClinic>.fl:nth-child(1)>div>div:nth-child(1)>p:nth-child(1) {
		margin-top: 214px;
	}
	
	.addClinic>.fl:nth-child(1)>div>div:nth-child(2)>p:nth-child(1) {
		margin-top: 22px;
	}
	
	.addClinic>.fl:nth-child(1)>div>div>p {
		font-size: 16px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(74, 74, 74, 1);
		line-height: 23px;
	}
	
	.addClinic>.fl:nth-child(1)>div>div:nth-child(1) {
		height: 645px;
		border-bottom: 3px solid #FFFFFF;
	}
	
	.addClinic>div:nth-child(2) {
		margin-left: 79px;
		height: 100%;
	}
	
	.zsxxFrom {
		overflow: hidden;
		border-bottom: 3px solid #FFFFFF;
	}
	
	.zsxxFrom>div:nth-child(1) {
		padding: 0 105px 0 70px;
		/*width:1075px;*/
		height: 60px;
		line-height: 60px;
		border-bottom: 2px solid #FFFFFF;
	}
	
	.zsxxFrom>div:nth-child(1)>div {
		float: right;
		width: 126px;
		height: 30px;
		margin-right: 20px;
	}
	
	.zsxxFrom>div:nth-child(1)>div:hover button {
		border: 2px solid #F8E71C;
	}
	
	.zsxxFrom>div:nth-child(1)>div>button {
		width: 126px;
		height: 30px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 16px;
		margin-top: 16px;
		cursor: pointer;
		margin-right: 10px;
	}
	
	.zsxxFrom>div>span {
		font-size: 16px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: rgba(74, 74, 74, 1);
		line-height: 23px;
	}
	
	.zsxxFrom>div:nth-child(2) {
		margin-top: 18px;
		margin-bottom: 18px;
		width: 100%;
		height: 609px;
		background: rgba(255, 255, 255, .7);
		border-radius: 3px;
	}
	
	.zsxxFrom>div:nth-child(2)>div:nth-child(2) {
		float: left;
		height: 606px;
		width: 50%;
	}
	
	.fromIpt {
		height: 619px;
		width: 50%;
		float: left;
	}
	
	.glzxx {
		height: 141px;
		width: 100%;
	}
	
	.glzxx>div {
		background: #FFFFFF;
		height: 100px;
		margin: 20px 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.glzxx>div>div {
		width: 33%;
		height: 100%;
		line-height: 100px;
		border-right: 1px dotted rgba(215, 217, 220, 1);
	}
	
	.glzxx>div>div:nth-child(3) {
		border-right: none;
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 0;
	}
	
	.glzxx>div>div:nth-child(3)>div {
		width: 126px;
		height: 30px;
	}
	
	.glzxx>div>div:nth-child(3)>div:hover button {
		border: 2px solid yellow;
	}
	
	.glzxx>div>div:nth-child(3)>div>button {
		width: 126px;
		height: 30px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 16px;
	}
	
	.glzxx>div>div>p>i {
		display: block;
		background: url(../../../assets/image/选中.png) no-repeat center center;
		background-size: 99%;
		width: 15px;
		height: 15px;
		float: left;
		margin-right: 5px;
		margin-top: 4px;
	}
	
	.glzxx>div>div>div {
		float: left;
		width: 170px;
		margin-left: 20px;
	}
	
	.glzxx>div>div>p {
		float: left;
		margin-left: 50px;
		margin-top: 38px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(34, 34, 34, 1);
		line-height: 23px;
	}
	
	.fromIpt>div {
		/*width: 50%;*/
		height: 509px;
		border-right: 1px dashed rgba(215, 217, 220, 1);
		border-left: 1px solid RGBA(245, 245, 245, 1);
		padding: 55px 70px;
	}
	
	.fromIpt1>div {
		/*width: 50%;*/
		height: 509px;
		padding: 55px 70px;
	}
	
	.fromIpt>div {}
	
	.comClass>p>i,
	.comClass1>p>i,
	.comClass2>p>i {
		display: block;
		background: url(../../../assets/image/选中.png) no-repeat center center;
		background-size: 100%;
		width: 15px;
		height: 15px;
		float: left;
		margin-right: 5px;
		margin-top: 4px;
	}
	
	.comClass>p,
	.comClass1>p,
	.comClass2>p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(34, 34, 34, 1);
		line-height: 23px;
		margin-bottom: 5px;
	}
	
	.comClass,
	.comClass1 {
		margin-bottom: 20px;
	}
	
	.selectDiv,
	.selectDiv1 {
		/*margin-right: 6px;*/
		margin-bottom: 10px;
	}
	.selectDiv1{
		margin-left: 6px;
	}
	.selectDiv>div {
		width: 113px;
		float: left;
		margin-right: 5px;
	}
	
	.selectDiv1>div {
		width: 123px;
		float: left;
		margin-right: 5px;
	}
	
	.selectDiv>span>p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		line-height: 20px;
	}
	
	.selectDiv1>span>p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		line-height: 40px;
	}
	
	.avatar-uploader {
		width: 177px;
		height: 130px;
		background: rgba(121, 139, 149, 0.44);
		box-shadow: 0px 0px 4px 0px rgba(155, 155, 155, 0.23);
		border-radius: 2px;
		text-align: center;
	}
	
	.avatar-uploader .el-icon-picture {
		font-size: 34px;
		color: #FFFFFF;
		line-height: 124px;
	}
	
	.el-upload img {
		width: 177px;
		height: 130px;
	}
	
	.comClass2 {
		margin-top: 50px;
	}
	
	.comClass2>div>div:nth-child(1) {
		/*margin-right: 10px;*/
		margin-bottom: 15px;
	}
	
	.comClass2>div>div>span {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(34, 34, 34, 1);
		line-height: 23px;
	}
</style>
<style>
	.avatar-uploader .el-upload {
		width: 177px !important;
		height: 130px !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/MA/clinicManagement/addClinic.vue